import {Link} from "react-router";

import {FormWarning} from "@/components/form/FormWarning.tsx";
import {humanFriendlyInt} from "@/lib/format.tsx";

interface InstantCheckoutSimpleWarningProps {
  limit: number;
  limit_name: string;
}

export const InstantCheckoutSimpleWarning = ({limit, limit_name}: InstantCheckoutSimpleWarningProps) => {
  const message = (
    <span>
      Your account has used {humanFriendlyInt(limit)} {limit_name} Check(s) and has reached its limit.
      <br />
      <Link to="/billing/manage-add-ons">
        <strong>Upgrade</strong>
      </Link>{" "}
      your subscription, or{" "}
      <Link to="/contact">
        <strong>contact us</strong>
      </Link>{" "}
      to add more {limit_name} Checks.
    </span>
  );
  return (
    <div className="mb-4">
      <FormWarning warnings={[message]} />
    </div>
  );
};
